import { deleteAuthToken } from "@/pages";
export const handleResponseRejected = (error) => {
    // Unauthorized
    if (error?.response?.status === 401) {
        deleteAuthToken();
        // TODO: Подумать, можно ли сделать это оптимальнее
        location.reload();
    }
};
